(function()
{
	"use strict";

	function CollectionView()
	{
		this.View_constructor();

		this.build();
	}

	var p = createjs.extend(CollectionView, cm.View);

	p.build = function()
	{
		cm.main.pause = false;
		cm.main.currentManifest = "Collection";
		this.width = cm.app.display.width * 0.5;
		this.height = cm.app.display.height * 0.5;
		this.background = new cjs.Bitmap(cm.Assets.lib.collectionbackground).center().set({ mouseEnabled: false });
		this.shipLoopSound = cm.app.sound.play("ship-bg-loop", -1);
		this.starfield = new cm.StarField();
		this.planetScaleTween = null;
		this.missedGarbageContainer = new cjs.Container().set({ mouseEnabled: false });
		this.collisionWrongContainer = new cjs.Container().set({ mouseEnabled: false });
		this.keysUsed = false;
		this.introStarted = false;
		this.levelShipEnd = false;
		this.endPlanetScale = false;
		this.ship = new cm.CollectionShip();
		this.ship.y = 150;
		this.firstCollectable = false;
		this.obstacleWarningPlayed = false;
		this.summonPlanet = false;
		this.grabbedGarbage = null;
		this.howToLoop = null;
		this.cursorTween = null;
		this.maskFillShapeTween = null;
		this.cursorSetXpos = 0;
		this.maskFillSetXpos = 0;
		this.wrongCount = 0;
		this.obstacleCount = 0;
		this.collectableItems = 0;
		this.movementAllowance = 20;
		this.levelSettings = cm.app.config.settings;
		cm.main.speed = this.levelSettings.levels[cm.main.selectedPlanetNum-1].speed;
		this.levelMultiplier = this.levelSettings.levels[cm.main.selectedPlanetNum-1].multiplier;
		this.spawnCount = this.levelSettings.levels[cm.main.selectedPlanetNum-1]["claw"+cm.main.gameSettings.grapple];
		this.garbagefield = new cm.GarbageField().set({ mouseEnabled: false });
		this.pixelMove = 430 / (this.levelMultiplier*(3+cm.main.gameSettings.grapple));
		this.maxScore = this.levelMultiplier * (3 + cm.main.gameSettings.grapple);
		this.easeX = 0;
		this.easeY = 0;
		this.currentScore = 0;
		this.npY = 1;
		this.npX = 1;
		this.moveValueY = 0;
		this.moveValueX = 0;
		this.lastMouse = { x: 0, y: 0 };
		this.keyNav = new cm.KeyBoardNav();
		this.keyNav.navArrow = this.navArrow = new cjs.Sprite(cm.Assets.lib.gameSS, "sort-home-btn").set({visible:false}).center();

		this.endPlanet = new cjs.Bitmap(cm.Assets.lib['planet-' + cm.main.selectedPlanetNum]).center();
		this.endPlanet.set({scaleX: 0, scaleY:0, alpha:0, snapToPixel:false});
		cm.app.music = null;

		if(cm.main.selectedPlanetNum === 5 && cm.main.gameSettings.grapple === 2 && cm.main.gameSettings.level5.challenge === 1)
			app.voPlayer.play([500, "vo-177"]);

			if(cm.main.selectedPlanetNum === 8 && cm.main.gameSettings.grapple === 3 && cm.main.gameSettings.level8.challenge === 1)
			app.voPlayer.play([500, "vo-177a"]);

		if(cm.main.gameSettings.level1.challenge === 1){
			if(cm.Device.mobile && cjs.Touch.isSupported()){
				app.voPlayer.play([2000, "vo-2"], this.endTutorialIntro.bind(this));
			}
			else{
				app.voPlayer.play([2000, "vo-2-alt"], this.endTutorialIntro.bind(this));
			}
		}
		else{
			this.startField();
		}

		this.addChild(this.background, this.endPlanet, this.starfield, this.garbagefield, this.collisionWrongContainer, this.ship, this.missedGarbageContainer);
		if(cm.main.selectedPlanet === "level-1-map-btn" && cm.main.gameSettings.level1.challenge === 1)
			this.setupIntroScene();

		this.addUI();
		this.garbagefield.setupSpawnCount();

	};

	p.endTutorialIntro = function()
	{
		cjs.Tween.get(this).wait(1000).call(this.garbagefield.sendSingleGarbage,  null, this.garbagefield);
		this.startField();
	};

	p.setupIntroScene = function()
	{
		var introSprite, introScore;
		if(cm.main.selectedPlanet === "level-1-map-btn"){
			this.introStarted = true;
			introSprite = new cjs.Sprite(cm.Assets.lib.junkSS, "soda").set({score:1, isCollectable: true, scaleX: 0.5, scaleY: 0.5, x: -50, y:-100}).center();
			introScore = this.addText("+1", 80, "#f9d735").set({x: 50, y:-100});
			this.addChildAt(introSprite, 4);
			this.addChild(introScore);
			this.createParticleEmitter(introSprite);
			cjs.Tween.get(this).wait(4000).call(this.introGrab, [introSprite], this);
			cjs.Tween.get(this).wait(4000).call(this.removeChild, [introScore], this);


		}
	};

	p.createParticleEmitter = function (garbage) {
        // Create the display object or an array of display objects we want as the particles

        var shapes = [
			new cjs.Sprite(cm.Assets.lib.gameSS, "particle").center()
        ];

        // Settings for the particle you want
        var particle = {
            shape: shapes,
            lifetime: { min: 1, max: 3 },
            speed: { min: 2, max: 4 },
            rotateSpeed: { min: -10, max: 10 },
            scale: { start: 1, end: 0.6 },
            opacity: { start: 1, end: 0 },
            force: { x: -3, y: 0 },
            gravity: { on: false, speed: 0 }
        };

        // Settings for the emitter
        var emitterSettings = {
            pos: { x: 0, y: 0 },
            particle: particle,
            count: 10,
            rate: 0,
            loop: false,
            burst: true,
            startOn: true
        };
        var particleEmitter = new cm.ParticleEmitter(emitterSettings);
		var sparkleContainer = new cjs.Container();
		sparkleContainer.x = garbage.x;
		sparkleContainer.y = garbage.y;
		sparkleContainer.addChild(particleEmitter);
		this.addChild(sparkleContainer);
		garbage.particle = sparkleContainer;
		// cjs.Tween.get(this).wait(1000).call(this.removeChild, [sparkleContainer], this);
    };

	p.introGrab = function(garbage)
	{
		var pt = this.localToLocal(garbage.x, garbage.y, this.ship);
		this.ship.triggerGrapple(garbage, pt);
		cjs.Tween.get(this).wait(200).call(this.removeChild, [garbage.particle], this).call(this.removeChild, [garbage], this).set({introStarted:false});
	};

	p.setSpawnTimers = function()
	{
		var singleTime, doubleTime, tripleTime;

		if(this.spawnCount.single > 0){
			singleTime = 4000;
			if(this.spawnCount.double < 1)
				doubleTime = 0;
			if(this.spawnCount.triple < 1)
				tripleTime = 0;
		}

		if(this.spawnCount.double > 0){
			doubleTime = 3000;
			if(this.spawnCount.single < 1)
				singleTime = 0;
			else
				singleTime = 6000;

			if(this.spawnCount.triple < 1)
				tripleTime = 0;
			else
				tripleTime = 5000;

		}

		if(this.spawnCount.triple > 0){
			tripleTime = 3000;
			if(this.spawnCount.single < 1)
				singleTime = 0;
			else
				singleTime = 6000;
			if(this.spawnCount.double <1)
				doubleTime = 0;
			else
				doubleTime = 5000;
		}

		return {single: singleTime, double: doubleTime, triple: tripleTime};
	};

	p.startField = function()
	{
		if(cm.main.gameSettings.level1.challenge === 1){
			this.sharedUI.mouseEnabled = true;
		}

		var timer = this.setSpawnTimers();
		if(timer.single>0)
			cjs.Tween.get(this, {loop: true}).wait(timer.single * cm.main.difficulty).call(this.garbagefield.sendSingleGarbage, null, this.garbagefield);

		if(cm.main.selectedPlanetNum > 4 && timer.double > 0 || cm.main.gameSettings.grapple > 1 && timer.double > 0)
			cjs.Tween.get(this, {loop: true}).wait(timer.double * cm.main.difficulty).call(this.garbagefield.sendDoubleGarbage, null, this.garbagefield);

		if(cm.main.selectedPlanetNum  > 7 && timer.triple > 0|| cm.main.gameSettings.grapple > 2 && timer.triple > 0)
			cjs.Tween.get(this, {loop: true}).wait(timer.triple * cm.main.difficulty).call(this.garbagefield.sendTripleGarbage, null, this.garbagefield);

		if(cm.main.gameSettings.level1.challenge !== 1){
			cjs.Tween.get(this, {loop: true}).wait(9000 * cm.main.difficulty).call(this.garbagefield.sendObstacle, null, this.garbagefield);

		}
		if(cm.main.selectedPlanetNum > 1 && !cm.main.gameSettings.presentCollected){
			cjs.Tween.get(this).wait(11000 * cm.main.difficulty).call(this.garbagefield.sendPresent, null, this.garbagefield);
		}

		cjs.Tween.get(this.garbagefield).wait(2000).to({alpha:1}, 500);
	};

	p.playObstacleWarning = function()
	{
		if(cm.main.gameSettings.level1.challenge === 1 && !this.obstacleWarningPlayed && !app.voPlayer.playing){
			this.obstacleWarningPlayed = true;
			app.voPlayer.play("vo-176");
		}
	};

	p.addUI = function()
	{
		this.sharedUI = new cm.SharedUI("CollectionView");
		this.sharedUI.y = -100;
		this.addScoreBar();
		if(cm.main.gameSettings.level1.challenge === 1){
			this.sharedUI.mouseEnabled = false;
			this.tutorialSparkle = new cjs.Sprite(cm.Assets.lib.gameSS, "sparkle").set({y:-325, alpha:0}).center();
			this.scoreBarContainer.addChildAt(this.tutorialSparkle, 0);
		}

		this.addChild(this.scoreBarContainer, this.navArrow, this.sharedUI);
		this.sharedUI.addButtonToKeyNav();
	};

	p.addScoreBar = function(){
		////SCOREBAR
		this.scoreBarContainer = new cjs.Container();
		this.scorebar = new cjs.Sprite(cm.Assets.lib.gameSS, "score-bar").center();
		this.scorebar.y = -325;
		var frontCover = new cjs.Sprite(cm.Assets.lib.gameSS, "front-cover").set({x:7, y:-322}).center();

		this.uiPlanet = new cjs.Sprite(cm.Assets.lib.gameSS, "ui-level-"+cm.main.selectedPlanetNum).center();
		this.uiPlanet.x = 332;
		this.uiPlanet.y = -319;
		var planetTextShadow = this.addText("Level "+cm.main.selectedPlanetNum, 20, "#000").set({x:this.uiPlanet.x, y: this.uiPlanet.y+48, alpha:0.5}).center();
		this.planetText = this.addText("Level "+cm.main.selectedPlanetNum, 20, "#f9d735").set({x:this.uiPlanet.x, y: this.uiPlanet.y+45}).center();

		///SCORE CURSOR
		var scoreCursor = new cjs.Sprite(cm.Assets.lib.gameSS, "score-cursor").center();
		this.scoreCursorText = this.addText(cm.main.score, 25, "#000");
		this.scoreCursorText.y = 19;
		this.scoreCursorText.textBaseline="middle";

		this.scoreCursorContainer = new cjs.Container();

		this.scoreCursorContainer.set({x:-208, y:-286});

		///FILL BAR SHAPE

		this.fillShape = new cjs.Sprite(cm.Assets.lib.gameSS, "fill-bar").set({x:6, y: -325, name: "fill-bar" }).center();

		//BAR SHAPE MASK

		var m = new cjs.Graphics();
		m.f("#fff").r(0,0, 440, 41);
		this.maskFillShape = new cjs.Shape(m);
		this.maskFillShape.set({x:-209, y:-346, regX: 440});
		this.maskFillShapeTween = cjs.Tween.get(this.maskFillShape);
		this.fillShape.mask = this.maskFillShape;

		this.scoreCursorContainer.addChild(scoreCursor, this.scoreCursorText);
		this.cursorTween = cjs.Tween.get(this.scoreCursorContainer);

		this.scoreBarContainer.addChild(this.scorebar, this.fillShape, frontCover, this.uiPlanet, planetTextShadow, this.planetText);
		var multiplier = this.levelMultiplier;
		var star, starText;
		for (var i = 0, l = 2+cm.main.gameSettings.grapple; i < l; i++) {
			star = new cjs.Sprite(cm.Assets.lib.gameSS, "score-star").set({x:-208+(this.pixelMove*multiplier), y:-326, name:"star"+i+1}).center();
			starText = this.addText(multiplier, 20, "#000").set({x:star.x, y:-312});
			starText.textBaseline= "middle";
			multiplier += this.levelMultiplier;

			this.scoreBarContainer.addChild(star, starText);
		}
		this.scoreBarContainer.addChild(this.scoreCursorContainer);
		this.scoreBarContainer.y = -4;
	};

	p.helpQuit = function()
	{
		this.helpContainer.visible = false;
		cm.main.pause = false;
		cjs.Tween.removeTweens(this.howToLoop);
		this.howToLoop = null;
		this.unPauseGame();
	};

	p.callHowToPopUp = function()
	{
		this.helpContainer.visible = true;
		cm.main.pause = true;
		this.howTo1.visible = true;
		app.voPlayer.play("vo-19", this.nextHelp.bind(this));

	};

	p.nextHelp = function()
	{
		this.howTo1.visible = false;
		app.voPlayer.play("vo-20", this.loopHelp.bind(this));

	};

	p.loopHelp = function()
	{
		this.howTo1.visible = true;
		this.howToLoop = cjs.Tween.get(this.howTo1, {loop:true}).wait(2000).set({visible: true}).wait(2000).set({visible: false});
	};


	p.addText = function(string, font, color)
	{
		var text = new cjs.Text(string, font+"px riffic-bold", color).center();
		return text;
	};

	p.start = function()
	{
		this.View_start();
		app.music = "sorting-game";
		app.musicInstance.volume = cm.main.musicVolume;
		cjs.Tween.get(this.sharedUI).wait(2000).call(cm.app.sound.play, ["button-drop"], cm.app.sound).to({y: -9}, 250, cjs.Ease.quadOut);

	};

	p.animateIn = function()
	{
		this.start();
		return 0;
	};

	p.animateOut = function () {
		return 2000;

	};

	p.pauseQuit = function()
	{
		this.pauseMenuContainer.visible = false;
		this.unPauseGame();
	};


	p.startObstaclePostIntro = function()
	{
		this.garbagefield.sendObstacleTutorial();
		cjs.Tween.get(this).wait(1500).call(this.playObstacleWarning, null, this);
		cjs.Tween.get(this, {loop: true}).wait(9000 * cm.main.difficulty).call(this.garbagefield.sendObstacle, null, this.garbagefield);

	};

	p.handleScore = function(score)
	{

		if(!this.firstCollectable && cm.main.selectedPlanet === "level-1-map-btn" && cm.main.gameSettings.level1.challenge === 1 && !app.voPlayer.playing){
			this.firstCollectable = true;
			app.voPlayer.play("vo-3", this.startObstaclePostIntro.bind(this));
			cjs.Tween.get(this.tutorialSparkle)
			.wait(2000)
			.to({rotation:180, alpha:1}, 1000)
			.to({rotation:360, alpha:0}, 1000);
		}
		this.scoreMultiplier = score;
		var testScore = cm.main.score + this.scoreMultiplier;
		var movePixel;
		var scoreDiffX = 0;

		if(this.maxScore < testScore){
			var diff = testScore - this.maxScore;
			var multiDiff = this.scoreMultiplier -diff;
			movePixel = this.pixelMove * multiDiff;

		}else{
			movePixel = this.pixelMove * this.scoreMultiplier;
		}

		if(this.scoreCursorContainer.x +movePixel > 215)
			scoreDiffX = 214 - (this.scoreCursorContainer.x + movePixel);

		if(this.maxScore > cm.main.score){
			this.cursorSetXpos = this.scoreCursorContainer.x + movePixel + scoreDiffX;
			this.maskFillSetXpos = this.maskFillShape.x + movePixel;
			this.cursorTween.to({ x: this.cursorSetXpos}, 150);
			this.maskFillShapeTween.to({ x: this.maskFillSetXpos}, 150);
			this.cursorTween.paused = false;
			this.maskFillShapeTween.paused = false;
		}
		this.scoreMultiplier = 0;
		cm.main.score++;
		this.currentScore = cm.main.score;
		cm.main.cursorPosition = this.scoreCursorContainer.x;
		this.collectableItems++;
		this.scoreCursorText.text = cm.main.score;
		this.scoreCursorText.center();
		this.checkEndLevel();
	};

	p.removeScore = function()
	{
		if(cm.main.score < 1){
			cm.main.score = 0;
			return;
		}
		this.cursorTween.to({x:this.cursorSetXpos - this.pixelMove}, 150);
		this.maskFillShapeTween.to({x:this.maskFillSetXpos - this.pixelMove}, 150);
		this.cursorTween.paused = false;
		this.maskFillShapeTween.paused = false;
		cm.main.score--;
		this.scoreCursorText.text = cm.main.score;
		this.scoreCursorText.center();
	};

	p.unPauseGame = function()
	{
		cm.main.pause = false;
	};

	p.checkEndLevel = function()
	{
		var diff;
		switch (cm.main.gameSettings.grapple)
		{
			case 1:
				diff = 17;
			break;
			case 2:
				diff = 23;
			break;
			case 3:
				diff = 26;
			break;
		}
		if(this.collectableItems >= (this.levelMultiplier * (3 + cm.main.gameSettings.grapple))-diff && !this.summonPlanet){
			this.summonPlanet = true;
			this.planetScaleTween = new cjs.Tween.get(this.endPlanet).to({scaleX:2, scaleY:2, alpha:2}, 30000);
		}
		if(this.collectableItems >= (this.levelMultiplier * (3 + cm.main.gameSettings.grapple))-15 && !this.levelEnd){
			this.sharedUI.mouseEnabled = false;
			this.sharedUI.endGameQuit();
			this.sharedUI.pauseMenuContainer.visible = false;
			if(app.voPlayer.playing){
				this.checkIsVOPlaying("vo-6", this.callEnd);
			}else{
				app.voPlayer.play("vo-6", this.callEnd.bind(this));
				cjs.Tween.get(this.garbagefield).to({alpha:0},200);
				cjs.Tween.get(this.missedGarbageContainer).to({alpha:0},200).wait(2000);
				this.levelEnd = true;
			}

			cm.main.gameSettings.trashCollected += cm.main.score;

		}
	};

	p.checkIsVOPlaying =  function (voFile, voFunction)
	{
		if(this.levelEnd){return;}
		if(app.voPlayer.playing){
			cjs.Tween.get(this).wait(500).call(this.checkIsVOPlaying, [voFile, voFunction], this);
		} else {
			app.voPlayer.play(voFile, voFunction.bind(this));
			cjs.Tween.get(this.garbagefield).to({alpha:0},200);
			cjs.Tween.get(this.missedGarbageContainer).to({alpha:0},200).wait(2000);
			this.levelEnd = true;
		}
	};

	p.callEnd = function()
	{
		cjs.Tween.get(cm.main).to({speed:0}, 1000);
		cjs.Tween.get(this.starfield).wait(1000).to({alpha:0}, 500);
		cjs.Tween.get(this)
		.wait(1000)
		.call(this.sendShipEnd, null, this);
	};

	p.sendShipEnd = function()
	{
		if(cm.main.score === 0 && !app.voPlayer.playing){
			app.voPlayer.play("vo-7-b");
		}
		this.levelShipEnd = true;
		cjs.Tween.get(this.ship)
		.to({x:-200, y:-200, rotation: 30, scaleX: 0.5, scaleY: 0.5}, 500)
		.call(this.loadSortView, null, this)
		.to({x:0, y:0, scaleX:0, scaleY:0}, 500)
		.wait(2000)
		.call(this.stopLoopSound, null, this);
	};

	p.stopLoopSound = function()
	{
		this.shipLoopSound.stop();
	};

	p.loadSortView = function()
	{
		cm.main.loadSceneTransition(["Sort", "Sort-" + cm.main.selectedPlanetNum], this.goToSortView.bind(this), "Collection");
	};
	p.goToSortView = function()
	{
		cm.ViewControl.gotoView("SortView");
	};

	p.goToView = function()
	{
		cm.ViewControl.gotoView("SpaceView");
		this.stopLoopSound();
	};

	// p.moveShip = function(e)
	// {
	// 	if(cm.main.pause || this.levelShipEnd){return;}
	// 	this.keysUsed = false;
	// 	this.mouseX = e.stageX - this.width;
	// 	this.mouseY = e.stageY - this.height;
	// };

	p.addScoreText = function(garbage)
	{
		if(garbage.score === 0){
			cm.main.gameSettings.presentCollected = true;
			app.sound.play("present-collect");
			app.voPlayer.play("vo-127");
			return;
		}
		var plusSprite;
		switch(garbage.score){
			case 1:
				plusSprite = new cjs.Sprite(cm.Assets.lib.gameSS, "plus1").center();
			break;
			case 2:
				plusSprite = new cjs.Sprite(cm.Assets.lib.gameSS, "plus2").center();
			break;
			case 3:
				plusSprite = new cjs.Sprite(cm.Assets.lib.gameSS, "plus3").center();

			break;
		}
		plusSprite.x = this.ship.x;
		plusSprite.y = this.ship.y;
		this.addChild(plusSprite);
		cjs.Tween.get(plusSprite).to({x: this.scoreCursorContainer.x, y: this.scoreCursorContainer.y}, 1000).call(this.handleScore, [garbage.score], this).to({alpha:0},250).call(this.removeObjectFromContainer, [plusSprite], this);
	};

	p.removeObjectFromContainer = function (object)
	{
		this.removeChild(object);
	};


	p.checkGarbageCollision = function(garbage)
	{
		if(this.ship.caughIt){return;}

		var cpt = this.localToLocal(garbage.x, garbage.y, this);
		var ranNeg, ranY;
		if(cpt.x > this.ship.x -200 && cpt.x < this.ship.x +200 && cpt.y < this.ship.y && cpt.y > this.ship.y - 200){
			if(garbage.isCollectable){
				var pt = this.localToLocal(garbage.x, garbage.y, this.ship);
				this.ship.garbageCollector.addChild(garbage);
				garbage.x = pt.x;
				garbage.y = pt.y;
				this.ship.triggerGrapple(garbage, pt);
				if(garbage.currentAnimation !== "present"){
					cm.main.garbageCollected.push(garbage.currentAnimation);
				}
				this.addScoreText(garbage);
			}else{
				if(this.wrongCount < 1 && !garbage.isObstacle){
					cm.main.pause = true;
				}

				this.wrongCount++;
				if(!garbage.isObstacle){
					this.collisionWrongContainer.addChild(garbage);
					ranNeg = Math.random() < 0.5 ? -1 : 1;
					ranY = Math.range(-384, 384);
					cjs.Tween.get(garbage).to({x:1664 * ranNeg, y:ranY, rotation:Math.range(180,720)}, 2000);
					this.ship.shipShake();
				}

				if(garbage.isObstacle && cpt.x > this.ship.x -150 && cpt.x < this.ship.x +150 && cpt.y < this.ship.y && cpt.y > this.ship.y - 150){
					if(this.obstacleCount < 1 && !app.voPlayer.playing && cm.main.selectedPlanet === "level-1-map-btn" && cm.main.gameSettings.level1.challenge === 1){
						this.obstacleCount++;
					}
					if(garbage.isTutorial){
						var sparkle = garbage.parent.getChildByName("sparkle");
						if(sparkle)
							sparkle.visible = false;
						garbage.isTutorial = false;
					}

					if(!this.ship.isWrong){
						if(!cm.main.pause)
							this.ship.wrongCollectable();

							this.collisionWrongContainer.addChild(garbage);

							ranNeg = Math.random() < 0.5 ? -1 : 1;
							ranY = Math.range(-384, 384);
							cjs.Tween.get(garbage).to({x:1664 * ranNeg, y:ranY, rotation:Math.range(180,720)}, 2000);
							var minusOne = new cjs.Sprite(cm.Assets.lib.gameSS, "minusone").center();
							minusOne.x = this.ship.x + 100;
							minusOne.y = this.ship.y + 20;
							this.addChild(minusOne);
							cjs.Tween.get(minusOne).to({x: this.scoreCursorContainer.x, y: this.scoreCursorContainer.y}, 1000).call(this.removeScore, null, this).to({alpha:0},250).call(this.removeObjectFromContainer, [minusOne], this);
							this.ship.shipShake();
					}
				}
			}
		}
	};

	p.setActive = function( bool )
	{
		if(bool)
		{
			this._stageEvent = cm.app.display.stage.on('stagemousedown', this.stageIneraction, this);
			// this.background.on("mousedown", this.moveShip, this);

			// if(cm.Device.mobile && cjs.Touch.isSupported()){
			// 	this.background.on("pressmove", this.moveShip, this);
			// 	this.movementAllowance = 40;
			// } else{
			// 	cm.app.display.stage.on('stagemousemove', this.moveShip, this);
			// }
		}
		else {
			this.keyNav.removeEventsOnButtons();
		}
	};

	p.stageIneraction = function(event) {
		if(cm.main.pause || this.levelShipEnd){return;}
		this.keysUsed = false;
	};

	p.lerp = function(start, end, amt){
		return (1-amt)*start+amt*end;
	};

	p.handleShipMovement = function()
	{
		if(cm.main.pause || this.levelShipEnd){return;}
		var stage = cm.app.display.stage;
		if (!this.keysUsed) {
			var w2 = cm.app.display.width * 0.5;
			var h2 = cm.app.display.height * 0.5;
			this.ship.x = this.lerp(this.ship.x, stage.mouseX ? stage.mouseX - w2 : 0, 0.1);
			this.ship.y = this.lerp(this.ship.y, stage.mouseY ? stage.mouseY - h2 : 0, 0.1);
		} else {
			this.easeY += (this.moveValueY * this.npY - this.easeY) * 0.1;
			this.easeX += (this.moveValueX * this.npX - this.easeX) * 0.1;
			this.ship.x += this.easeX;
			this.ship.y += this.easeY;
		}

		this.ship.x = Math.limit(this.ship.x, -512, 512);
		this.ship.y = Math.limit(this.ship.y, -250, 250);

		this.lastMouse.x = stage.mouseX;
		this.lastMouse.y = stage.mouseY;

		var percentage = Math.abs(this.ship.x) / 512;
		var posNeg = 1;
		if(this.ship.x < 0)
			posNeg = 1;
		else
			posNeg = -1;
		this.ship.rotation = 30 * percentage * posNeg;
	};

	p.handleKeyPress = function()
	{
		if(cm.main.pause || this.levelShipEnd){return;}

		if(cm.Keyboard.state("upKey") || cm.Keyboard.state("rightKey") || cm.Keyboard.state("downKey") || cm.Keyboard.state("leftKey")){
			this.keysUsed = true;
		}

		if(cm.Keyboard.state("rightKey")){
			this.npX = 1;
		}

		if(cm.Keyboard.state("leftKey")){
			this.npX = -1;
		}

		if(cm.Keyboard.state("upKey")){
			this.npY = -1;
		}

		if(cm.Keyboard.state("downKey")){
			this.npY = 1;
		}
		if(!cm.Keyboard.state("upKey") && !cm.Keyboard.state("downKey")){
			this.npY = this.moveValueY = 0;
		}
		else{
			this.moveValueY = 20;
		}

		if(!cm.Keyboard.state("rightKey") && !cm.Keyboard.state("leftKey")){
			this.npX = this.moveValueX = 0;
			// if(!cm.Keyboard.state("upKey") && !cm.Keyboard.state("downKey"))
		}
		else{
			this.moveValueX = 20;
		}


	};

	p.keyNavHandle = function(button)
	{

		switch(button.name){
			case "help-bg":
			case "pause-bg":
				this.sharedUI.handleClick(button.name);
			break;
		}
	};

	p.replayLevel = function()
	{
		cm.main.score = 0;
		cm.main.pause = false;
		cm.ViewControl.gotoView("CollectionView");
		cm.ViewControl.transitIn();
	};

	p.update = function()
	{
		if(cm.Keyboard){
			this.keyNav.keyCheck();
			cm.Keyboard.clearPressed();
		}
		if(cm.main.pause){
			if(this.planetScaleTween)
				this.planetScaleTween.paused = false;
			return;
		}

		if(this.planetScaleTween)
			this.planetScaleTween.paused = false;

		// if(this.starfield){
		// 	this.starfield.moveField();
		// }
		if(this.garbagefield && !this.levelEnd){
			this.garbagefield.moveGarbageField();
			this.garbagefield.moveMissedGarbage();
		}
		if(this.ship && !this.introStarted){
			if(!cm.Device.mobile){
				this.handleKeyPress();
			}
			this.handleShipMovement();
		}

	};

	p.resize = function()
	{
		this.sharedUI.resize();
	};

	p.destroy = function()
	{
		cm.app.display.stage.off("stagemousedown", this._stageEvent);
		this.View_destroy();
	};

	cm.View.CollectionView = cjs.promote(CollectionView, "View");
})();